import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';

import styles from 'src/components/layout/landlord/NavigationLink.module.css';

type Props = {
    text?: React.ReactNode;
    icon?: React.ReactNode;
    link?: string;
    onClick: () => void;
    testId?: string;
};

export default function NavigationLink({
    text,
    icon,
    link,
    onClick,
    testId,
}: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const isSubLink = !icon;
    const isSelected = !!link && location.pathname === link;
    const color = isSelected ? '#0C8C62' : '#615F57';

    const handleClick = () => {
        onClick();

        if (link) {
            navigate(link);
        }
    };

    const renderedIcon = isSubLink ? (
        isSelected ? (
            <div className={styles.subNavActiveIndicator}>
                <div className={styles.subNavPartialIndicator} />
            </div>
        ) : (
            <div className={styles.subNavIndicator} />
        )
    ) : icon;

    return (
        <>
            <ListItem disablePadding data-testid={testId ?? `${text}-link`}>
                <ListItemButton
                    className={isSubLink ? `${styles.button} ${styles.subLinkButton}` : styles.button}
                    onClick={handleClick}
                    disableRipple={isSubLink}
                    sx={isSubLink ? {} : { bgcolor: isSelected ? 'primary.50' : 'invalid' }}
                >
                    <ListItemIcon className={isSubLink ? styles.iconContainerSubLink : styles.iconContainer}>
                        {renderedIcon}
                    </ListItemIcon>
                    {!!text && (
                        isSubLink ? (
                            <span className={`${styles.subLinkText} ${isSelected ? styles.selected : ''} ellipsisText`}>
                                <Typography fontWeight={400} fontSize={14} color={color} component="span">{text}</Typography>
                            </span>
                        ) : (
                            <Typography fontWeight={400} fontSize={14} color={color} component="span" className="ellipsisText">{text}</Typography>
                        )
                    )}
                </ListItemButton>
            </ListItem>
        </>
    );
}
